import { createStyles } from 'antd-style'

export const useStyle = createStyles(({ token }) => ({
  workspaceCard: {
    height: '100%',
    cursor: 'pointer',
    borderRadius: token.borderRadiusLG,
    background: token.colorBgContainer,
    transition:
      'transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease',

    '&:hover': {
      transform: 'translateY(-1px)',
      borderColor: token.colorPrimaryBorderHover,
      boxShadow: token.boxShadowSecondary
    },

    '&:hover .ws-arrow': {
      opacity: 1,
      color: token.colorPrimaryText,
      transform: 'translate(2px, -2px)'
    },

    '&:active': {
      transform: 'translateY(0)'
    },

    '&:focus-visible': {
      outline: `2px solid ${token.colorPrimaryBorder}`,
      outlineOffset: 2,
      borderColor: token.colorPrimary
    }
  },

  content: {
    height: '100%'
  },

  workspaceName: {
    display: 'block',
    fontSize: token.fontSize,
    fontWeight: 600,
    color: token.colorText,
    lineHeight: 1.3
  },

  workspaceDomain: {
    display: 'block',
    fontSize: token.fontSizeSM,
    color: token.colorTextTertiary,
    fontFeatureSettings: '"tnum"'
  },

  roleTag: {
    marginInlineEnd: 0,
    textTransform: 'capitalize',
    border: 'none',
    borderRadius: 999,
    padding: '0 8px',
    fontSize: 11,
    lineHeight: '18px',
    fontWeight: 500
  },

  divider: {
    height: 1,
    background: token.colorBorderSecondary
  },

  footer: {
    minHeight: 20
  },

  meta: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden'
  },

  metaIcon: {
    color: token.colorTextTertiary,
    flexShrink: 0
  },

  metaText: {
    fontSize: token.fontSizeSM,
    color: token.colorTextSecondary,
    whiteSpace: 'nowrap'
  },

  metaDot: {
    width: 3,
    height: 3,
    borderRadius: '50%',
    background: token.colorTextQuaternary,
    flexShrink: 0
  },

  openIcon: {
    flexShrink: 0,
    color: token.colorTextTertiary,
    opacity: 0.6,
    transition: 'opacity 160ms ease, transform 160ms ease, color 160ms ease'
  }
}))
